// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2yd9A","header":"Messages_header__2XjlS"};